import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-features-hero.png`}
        alt="Lady grooming dog in grooming salon"
        height={4000}
        width={2000}
      />

      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>Pet Care Bookings made easy </h1>
            </TextWithHighlight>
            <p>
              Explore all the <strong>Pata features designed to streamline your pet care business </strong> – from the
              appointments calendar and your own profile page to waiting lists and more. No clutter, no irrelevant
              extras – just the features you truly need.
              <br />
            </p>
            <p>Get started with Pata’s ultimate pet care booking platform in no time, at no cost.</p>

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Join Pata</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          <Image
            src={`${VITE_CDN_BASE_URL}/images/image-features-hero.png`}
            alt="Lady grooming dog in grooming salon"
            height={2000}
            width={2000}
          />
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
